module.exports = __webpack_public_path__ + "img/public_request_geninfo_960.b1f8c83d.png";